
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.742 5.575L9.425 7.892A1.742 1.742 0 009 7.833c-.92 0-1.667.746-1.667 1.667.002.143.022.286.059.425l-.65.65a.833.833 0 000 1.183.834.834 0 001.183 0l.65-.65c.139.037.281.057.425.059.92 0 1.667-.747 1.667-1.667a1.743 1.743 0 00-.059-.425l2.317-2.317a.837.837 0 10-1.183-1.183zM9 .333A8.333 8.333 0 00.667 8.667 8.258 8.258 0 002.075 13.3a.834.834 0 101.383-.933 6.667 6.667 0 1111.084 0 .833.833 0 00.691 1.3.833.833 0 00.692-.367 8.258 8.258 0 001.408-4.633A8.333 8.333 0 009 .333z","fill":"#fff"}})])
          )
        }
      }
    